import { createAsyncThunk } from '@reduxjs/toolkit';
import incidentApi from '~/apis/incident';
import { IFormIncident } from '~/utils/interface/incident';
import { CREATE_INCIDENT, DELETE_INCIDENT } from '~/utils/constants/actionType';

export const createIncident = createAsyncThunk(CREATE_INCIDENT, async (body: IFormIncident, { rejectWithValue }) => {
  try {
    const resp = await incidentApi.createIncident(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteIncident = createAsyncThunk(DELETE_INCIDENT, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await incidentApi.deleteIncident(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
